export const css = {
    root: '_3Od9sEJl',
    ' _key': 'apic-theme/dojo/variants/dark'
};
export default css;
